module.exports = __webpack_public_path__ + "static/model-keycap-v-a224cc3076bb6ec02668cf3c7c37ab9d.png";